var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page page-home"},[_c('section',{staticClass:"content-container"},[_c('ViewFeedContainer')],1),(!_vm.$store.getters['settings/pwaInstallStatus'])?_c('ViewLayoutPwaNotification'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }